import React from 'react'
import UserAvatar from '../user-avatar/UserAvatar'
import './UserList.less'

declare interface IUserListItem {
  display_name: string
  userIdentity: string
  image_url: string | null
}

const UserList = ({ users }: { users: IUserListItem[] }) => {
  return (
    <ul className="UserList">
      {users.map((user) => {
        return (
          <li key={user.userIdentity}>
            <UserAvatar user={user} />
            {user.display_name}
            <span className="UserList__email">{user.userIdentity}</span>
          </li>
        )
      })}
    </ul>
  )
}

export default UserList
